import { SupplierNetworkApi } from '../../infrastructure/api';
import { SupplierNetworkStorage } from '../../infrastructure/storage';
import { SupplierNetwork } from '../../domain/entities';

export class LoadSupplierNetworkUseCase {
    async execute(cnpj?: string): Promise<SupplierNetwork | null> {
        if (cnpj) {
            const supplierNetwork = await SupplierNetworkApi.fetchByCNPJ(cnpj);
            await SupplierNetworkStorage.save(supplierNetwork);
            return supplierNetwork;
        }

        return await SupplierNetworkStorage.load();
    }
}

